import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  icon: '📖',
  title: '150 páginas con amor',
  description: '55 preguntas que recorren toda su vida: infancia, amor, familia, sueños y legado.'
}, {
  icon: '🖼️',
  title: 'Espacio para fotos',
  description: 'Cada pregunta tiene espacio para escribir y para pegar imágenes de esos momentos únicos.'
}, {
  icon: '🖨️',
  title: '100% imprimible',
  description: 'Formato PDF. Lo imprimís, lo encuadernás y se convierte en un libro físico único e irrepetible.'
}, {
  icon: '📥',
  title: 'Acceso inmediato',
  description: 'Apenas confirmás el pago, recibís todo en tu email. En minutos podés descargarlo.'
}, {
  icon: '🎨',
  title: '2 diseños de portada',
  description: 'Ilustraciones suaves y elegantes para elegir la que más le quede a ella.'
}, {
  icon: '👨‍👩‍👧‍👦',
  title: 'Para toda la familia',
  description: 'También disponible para papá, abuelo y abuela. Guardá el legado completo de tu familia.'
}];
export function ProductDescription() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-4" data-id="element-200">
            Un libro guiado. Un legado eterno.
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-201">
            No es un cuaderno en blanco que intimida. Es un libro con preguntas
            profundas diseñadas para despertar recuerdos que de otra forma se
            perderían para siempre.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-orange-50 rounded-lg p-6 hover:shadow-lg transition-shadow" data-id="element-203">
              <div className="text-4xl mb-4" data-id="element-204">{feature.icon}</div>
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-3" data-id="element-205">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-206">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}